const state = {

  appName: null,
  app: null,
  ip_address: null,
  refresh_key: 0,
  mjml_key: 0,
  dark_mode: false,

  header: true,
  titlebar: false,
  events: false,

  app_list: [],
  email_template: null,

  default_country: 'US',
  countries: ['US'],

  expand_group: null,
  
  launch: {
    storage_key: process.env.VUE_APP_STORAGE_KEY,
    favicon_url: process.env.VUE_APP_FAVICON,
    tab_title: process.env.VUE_APP_TAB_TITLE,
    background_url: process.env.VUE_APP_LAUNCH_IMAGE_URL,
    background_color: process.env.VUE_APP_THEME_DARK_BACKGROUND,
    text_color: "#f8f8f8",
    logo_url: process.env.VUE_APP_HOST_LOGO,
    host_url: process.env.VUE_APP_HOST_URL,
    title: process.env.VUE_APP_APP_NAME,
    subtitle: process.env.VUE_APP_APP_TAGLINE,
    login_url: process.env.VUE_APP_LOGIN_IMAGE_URL,
  },
};

const getters = {};

const mutations = {
  updateShippingOptions(state, n) {
    state.shipping_options = n;
  },
  updateLinks(state, n) {
    state.policies = n;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
